import { AlertTriangle, Truck } from "lucide-react";
import { filterLabels } from "./purchase-order-presentation";

import type { PurchaseOrdersViewState } from "./purchase-order-view-state";
import { PurchaseOrderRow } from "./PurchaseOrderRow";
type Props = Pick<PurchaseOrdersViewState,
  | "isPlanning"
  | "loading"
  | "loadError"
  | "load"
  | "visible"
  | "filter"
  | "isSpecialist"
  | "candidates"
  | "expanded"
  | "focusedOrderId"
  | "setExpanded"
  | "isQuality"
  | "setQualityStatus"
  | "setQualityNote"
  | "setQualityDisposition"
  | "setOperationError"
  | "setDialog"
  | "documentUrl"
  | "submitting"
  | "setDispatchRecipient"
  | "setDeliveryAddress"
  | "openReceipt"
  | "setNote">;

export function PurchaseOrdersList({
  isPlanning,
  loading,
  loadError,
  load,
  visible,
  filter,
  isSpecialist,
  candidates,
  expanded,
  focusedOrderId,
  setExpanded,
  isQuality,
  setQualityStatus,
  setQualityNote,
  setQualityDisposition,
  setOperationError,
  setDialog,
  documentUrl,
  submitting,
  setDispatchRecipient,
  setDeliveryAddress,
  openReceipt,
  setNote,
}: Props) {
  return (<section
    className={`purchase-order-list is-operational ${isPlanning ? "is-planning-view" : ""}`}
  >
    {loading ? (
      <div className="purchase-order-empty">Siparişler yükleniyor…</div>
    ) : null}
    {!loading && loadError ? (
      <div className="purchase-order-inline-error" role="alert">
        <AlertTriangle size={18} />
        <div>
          <strong>Veri alınamadı</strong>
          <span>{loadError}</span>
        </div>
        <button className="secondary-button" onClick={() => void load()}>
          Yeniden dene
        </button>
      </div>
    ) : null}
    {!loading &&
      !loadError &&
      visible.length === 0 &&
      !(filter === "ACTION" && isSpecialist && candidates.length) ? (
      <div className="purchase-order-empty">
        <Truck size={25} />
        <strong>{filterLabels[filter]} görünümünde kayıt yok</strong>
        <span>Bu operasyon grubuyla eşleşen sipariş bulunmuyor.</span>
      </div>
    ) : null}
    {!loading && !loadError && visible.length > 0 ? (
      <div className="purchase-order-list-head" aria-hidden="true">
        <span>Sipariş</span>
        <span>Miktar / ilerleme</span>
        <span>Planlanan teslimat</span>
        <span>{isPlanning ? "Sorumlu" : "Sıradaki aksiyon"}</span>
        {!isPlanning ? <span>Sipariş tutarı</span> : null}
        <span />
      </div>
    ) : null}
    {visible.map((order) => (<PurchaseOrderRow
      key={order.id}
      expanded={expanded}
      focusedOrderId={focusedOrderId}
      setExpanded={setExpanded}
      isPlanning={isPlanning}
      isSpecialist={isSpecialist}
      isQuality={isQuality}
      setQualityStatus={setQualityStatus}
      setQualityNote={setQualityNote}
      setQualityDisposition={setQualityDisposition}
      setOperationError={setOperationError}
      setDialog={setDialog}
      documentUrl={documentUrl}
      submitting={submitting}
      setDispatchRecipient={setDispatchRecipient}
      setDeliveryAddress={setDeliveryAddress}
      openReceipt={openReceipt}
      setNote={setNote}
      order={order}
    />))}
  </section>);
}
